export default __webpack_public_path__ + "static/3-359b1411870ac69b070539ff7f4b726f.png";